import { TableRow, useTheme } from "@mui/material";
import { Row } from "@tanstack/react-table";

export const HoverRow = <T,>(
    props: React.PropsWithChildren<
        Row<T> & { selected?: boolean; clickable?: boolean; onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void }
    >,
) => {
    const theme = useTheme();
    const clickable = props.clickable !== false;

    const defaultBackground =
        theme.palette.mode === "dark" ? theme.palette.emteria.background.tableCells : theme.palette.emteria.text.inverse;

    const selectedBackground = theme.palette.emteria.background.selectedRow;
    const hoverBackground = theme.palette.emteria.background.listHover;

    return (
        <TableRow
            style={{
                cursor: clickable ? "pointer" : "default",
                backgroundColor: props.selected ? selectedBackground : defaultBackground,
            }}
            onClick={props.onClick}
            onMouseEnter={(e) => {
                if (!props.selected) {
                    e.currentTarget.style.backgroundColor = hoverBackground;
                }
            }}
            onMouseLeave={(e) => {
                if (!props.selected) {
                    e.currentTarget.style.backgroundColor = defaultBackground;
                }
            }}
        >
            {props.children}
        </TableRow>
    );
};
